var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',[(_vm.field?.snippets?.[_vm.data.item?.[_vm.field.key]])?_c('span',{staticClass:"badge badge-info"},[_vm._v(" "+_vm._s(_vm.field.snippets[_vm.data.item[_vm.field.key]]))]):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }